import React from 'react';
import { Calendar, MapPin } from 'react-feather';
import { QRCodeCanvas } from 'qrcode.react';
import { format } from 'date-fns';

import { dateGlobalPattern } from 'utils/dateUtils';
import { formatCurrency } from 'utils/currencyUtils';
import * as S from './styles';

interface TicketVisualProps {
	ticket: {
		attendeeCode: string;
		attendeeFirstName: string;
		attendeeLastName: string;
		ticketName: string;
		ticketBatch: string;
		ticketPrice: number;
	};
	event: {
		name: string;
		startDate: string;
		customDate: string;
		fullAddress: string;
		locationType: string;
		thumbnail: string;
	};
}

const iconSize = 14;

const TicketVisual = ({ ticket, event }: TicketVisualProps) => {
	const eventDate = (event.customDate && event.customDate.length > 0)
		? event.customDate
		: format(new Date(dateGlobalPattern(event.startDate)), 'dd/MM/yyyy HH:mm');

	const eventLocation = event.locationType === 'PHYSICAL' ? event.fullAddress : 'Evento online';

	return (
		<S.TicketCard>
			<S.TicketBanner thumbnail={event.thumbnail} />

			<S.TicketBody>
				<S.EventName>{event.name}</S.EventName>

				<S.InfoRow>
					<Calendar size={iconSize} />
					<S.InfoText>{eventDate}</S.InfoText>
				</S.InfoRow>

				<S.InfoRow>
					<MapPin size={iconSize} />
					<S.InfoText>{eventLocation}</S.InfoText>
				</S.InfoRow>

				<S.Divider />

				<S.AttendeeName>{ticket.attendeeFirstName} {ticket.attendeeLastName}</S.AttendeeName>
				<S.TicketType>{ticket.ticketName} &middot; {ticket.ticketBatch}</S.TicketType>
				<S.TicketType>{formatCurrency(ticket.ticketPrice)}</S.TicketType>

				<S.QRCodeWrapper>
					<QRCodeCanvas value={ticket.attendeeCode} size={180} level="H" bgColor="#ffffff" fgColor="#000000" marginSize={2} />
					<S.AttendeeCode>{ticket.attendeeCode}</S.AttendeeCode>
				</S.QRCodeWrapper>
			</S.TicketBody>
		</S.TicketCard>
	);
};

export default TicketVisual;
